import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { IconButton, SwipeableDrawer, Tooltip } from '@mui/material'
import * as OnboardEntity from '../../../Entities/OnBoardingContainerTypes'
import PeriodicityComponent from './PeriodicityComponent'
import { calculateDaysAgo } from 'src/lib/utils'
import { useRiskStore } from 'src/Containers/Risk/Store/RiskStore'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import { useIssueStore } from 'src/Containers/IssueRegister/store/IssueStore'

function PeriodicityCont ({ timelineType, apiCall, type = 'RISK' }, ref) {
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const [ editState, setEditState ] = useState({ right: false })

    const currentDate = new Date()
    const [ daysAgo, setDaysAgo ] = useState(calculateDaysAgo(currentDate, new Date()))
    const [ data, setData ] = useState([])
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    const getRiskPeriodicityData = useRiskStore(state => state?.getRiskPeriodicityData)
    const getIssuePeriodicityData = useIssueStore(state => state?.getIssuePeriodicityData)
    useEffect(() => {
        if (type === 'RISK') {
            setData(getRiskPeriodicityData)
        } else {
            setData(getIssuePeriodicityData)
        }
    }, [ getRiskPeriodicityData,
        getIssuePeriodicityData ])
    useEffect(() => {
        if (editState.right) apiCall()
    }, [editState])
    useImperativeHandle(ref, () => {
        return {
            toggleDraw: () => {
                toggleDrawer('right', true)()
            }
        }
    }, [])
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
               event.type === OnboardEntity.KEYDOWN &&
               (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }
        setEditState({ ...editState, [anchor]: open })
    }
    const riskDetailsLoading = useRiskStore(state => state?.riskDetailsLoading)

    return (
        <>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 2, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={editState.right && !riskDetailsLoading}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                <div className='h-full  !bg-card'>
                    <div className='flex border-b-[1px] pb-3 p-4 items-center justify-between'>
                        <div className="text-h0 font-bold flex gap-5 items-center text-primary" >{ 'Periodicity' } <span className='text-muted !text-h4'>{daysAgo}</span></div>
                        <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton onClick={() => setEditState({ right: false })} aria-label="close">
                                <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <PeriodicityComponent getData={data} type={type} setDaysAgo={setDaysAgo} />
                </div></SwipeableDrawer>
        </>
    )
}

export const PeriodicityContainer = forwardRef(PeriodicityCont)
